module.exports = __webpack_public_path__ + "static/img/pillar-base_256.77110c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pillar-base_256.png
// module id = I/3r
// module chunks = 0